import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-pilots',
  templateUrl: './pilots.component.html',
  styleUrls: ['./pilots.component.scss']
})
export class PilotsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  selectedBase;
  pilots = [];
  userIsSysAdmin = false;
  bases = [];
  headings = [
    {
      label: 'Name',
      key: 'fullName'
    },
    {
      label: 'Affiliations',
      key: 'affiliation'
    },
    {
      label: 'Active',
      key: 'friendlyActive'
    }
  ];
  settings = {
    label: 'New Pilot',
    action: 'create',
    target: 'pilots',
    route: 'pilots'
  };

  constructor(private toast: ToastService) {}

  ngOnInit() {
    if (this.userInfo.role == 'sysadmin') {
      this.userIsSysAdmin = true;
    }

    axios
    .get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    })
    .then((response) => {
      this.bases = response.data;

      this.bases.forEach((base) => {
        base.name = base.text + ' | ' + base.baseCode;
        base.value = base.baseId;

        if (base.baseCode === this.userInfo.baseCode) {
          this.selectedBase = base;
        }
      });

      this.refreshPilots();

    })
    .catch((error) => {
      console.dir(error);
    });

    this.refreshPilots();
  }

  selectHomeBase(selectedBase) {
    this.selectedBase = selectedBase;
    this.refreshPilots();
  }

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.pilot);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDeletePilot = (pilot) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this pilot?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        pilot: pilot
      },
      active: true
    };
  };

  delete = async (pilot) => {
    let userId = this.userInfo.id;
    let id = '';
    if (pilot.id) {
      id = pilot.id;
    } else if (pilot.href) {
      id = pilot.href.slice(
        pilot.href.indexOf('/pilots/') + '/pilots/'.length,
        pilot.href.length
      );
    }
    let deleted = await axios
      .delete(
        environment.API_URL + '/pilots/' + id + '/delete?userId=' + userId,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Pilot', 'success');
        this.refreshPilots();
      })
      .catch((error) => {
        this.toast.showFullError('Unable to Delete Pilot', error);
      });
  };

  refreshPilots = () => {
    this.loading = true;
    let baseCode = this.selectedBase.baseCode;
    axios
      .get(environment.API_URL + '/pilots?baseCode=' + baseCode, {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.pilots = response.data.value;
        this.pilots.forEach((pilot) => {
          pilot.fullName = pilot.lastName + ', ' + pilot.firstName;
          pilot.friendlyActive = pilot.active ? 'Yes' : 'No';
        });

        this.pilots = this.sort(this.pilots, 'active');
        this.pilots = this.sort(this.pilots, 'fullName');
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.toast.showFullError('Unable to retreive pilots list.', error);
      });
  };

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };
}
